// extracted by mini-css-extract-plugin
export default {"wrapper":"Logo_wrapper__dTJLj","s":"Logo_s__mEnEf","m":"Logo_m__nPfBo","l":"Logo_l__aGAKO","ayuntamiento":"Logo_ayuntamiento__1q4qr"};